import { ProductSlim } from "~/use-cases/contracts/Product";
import { Chunk } from "../api-mappers";

export default (chunk?: Chunk[]) => {
  return !chunk
    ? {
        otc: false,
        otcRestrictions: [] as Array<ProductSlim>,
      }
    : (chunk.reduce(
        (memo: Record<string, any>, data: any) => {
          switch (data.type) {
            case "boolean":
              memo.otc = data.getCartOrderIntent?.otc || false;
              break;
            case "itemRelation":
              memo.otcRestrictions = data.content?.otcRestrictions || [];
              break;
            default:
              break;
          }
          return memo;
        },
        {
          otc: false,
          otcRestrictions: [] as Array<ProductSlim>,
        },
      ) as { otc: boolean; otcRestrictions: Array<ProductSlim> });
};
